import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { DataRoomLenderStatusBar, Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDataRoomLenderStatusBarQuery(
	dataRoomGuid?: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<DataRoomLenderStatusBar, unknown, DataRoomLenderStatusBar, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.LenderStatusBar(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomLenderStatusBar>(
				api.get(CerebroApiEndpoints.DataRooms.LenderStatusBar(dataRoomGuid))
			),
		options
	);
}
